import { render, staticRenderFns } from "./modalCondiciones.vue?vue&type=template&id=6b948521&scoped=true"
import script from "./modalCondiciones.vue?vue&type=script&lang=js"
export * from "./modalCondiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b948521",
  null
  
)

export default component.exports